import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DateTimePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import { REQUEST_FORM_FIELD_NAME_DATE } from '../../RequestForm.constants'

function DeadlineField(props) {
  const { t } = useTranslation()
  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      Component={DateTimePicker}
      borderless={!isMobileScreenSize}
      dateProps={{
        placeholder: t('Request.DeadlinePlaceholderKey'),
      }}
      fieldComponentProps={{
        label: `${t('Request.DeadlineLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      name={REQUEST_FORM_FIELD_NAME_DATE}
      separator='/'
      timeProps={{
        placeholder: t('Request.DeadlineTimePlaceholderKey'),
      }}
    />
  )
}

export default DeadlineField
